export default "__VITE_ASSET__YjmMfYjK__"